<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900 tabular-nums">
      <div class="flex space-x-4">
        <div class="w-48">
          <div class="aspect-w-16 aspect-h-9" :class="[!cover && 'bg-gray-200 rounded shadow']">
            <img v-if="cover" :src="cover.url" class="w-full rounded shadow object-cover" />
          </div>
        </div>
        <div class="flex-1">
          {{ product.name }}
        </div>
      </div>
    </td>
    <td class="px-4 py-4 text-right align-top">
      <div class="space-x-2 whitespace-nowrap">
        <ProductRemoveAction
          :acc-product-id="accProductId"
          :product="product"
          @product-removed="onProductRemoved"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import ProductRemoveAction from './ProductRemoveAction.vue';

export default {
  components: {
    ProductRemoveAction,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    accProductId: {
      type: String,
      required: true,
    },
  },
  computed: {
    cover() {
      return this.product?.media?.[0] || null;
    },
  },
  methods: {
    onProductRemoved(removedProduct) {
      this.$emit('product-removed', removedProduct);
    },
  },
};
</script>
